/* loaded by smart-asset */
export default require("./respondent~bpLcskDR.png")